module.exports = __webpack_public_path__ + "static/media/jmp-logo.635821f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/jmp-logo.png
// module id = 593
// module chunks = 19